import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TestRunService {
  private testRun: boolean = false;

  setTestRun(value: boolean): void {
    this.testRun = value;
  }

  isTestRun(): boolean {
    return this.testRun;
  }
}
